import Util from "./Util"

/* eslint-disable no-extend-native */
export {}

interface IMonthYYYY {
    yyyymm: number
    text: string
}

declare global {
    // https://github.com/Microsoft/TypeScript/issues/7726#issuecomment-204056766
    interface Date {
        // isToday(): boolean
        yyyymmdd(): string
        yyyymmddAsNumber(): number
        yyyymm(): number
        day_name(): string
        month_shortname(): string | null
        monthyyyy(): IMonthYYYY
        hhmmddmmyyyy(): string
        ddmmyyyy_ui(): string
        ddmmyyyy_ui2(): string
        ddmmyyyy_ui3(): string
        ddmmyyyy_ui4(): string
        ddmmyyyy_data(): string
        yyyymmddhhMMssfff_data(): string
        yyyymmddhhMMssfff(): string
        HHMM_ui2(): string
        HHMM_ddmmyyyy_ui2(): string
        HHMM_ddmmyyyy_ui3(): string
        ddmmyyyy_HHMM_ui2(): string
        hhmmssfff(): string
        hhmmss(): string
    }
}

// Date.prototype.isToday = (): boolean => {
//     let today = new Date()
//     console.log(this) // WILL RETURN FIRST EXPORTED ANGULAR2 OBJECT IN THIS FILE
//     return today.getFullYear() === this.getFullYear() && today.getMonth() === this.getMonth() && today.getDate() === this.getDate()
// }

export interface IYYYYMMDD {
    yyyy: number
    mm: number
    dd: number
}

export const split_dateString = (dateString: string | undefined | null): IYYYYMMDD | undefined => {
    if (!dateString) return undefined

    const yyyy = parseInt(dateString.substring(0, 4), 10)
    if (!yyyy || isNaN(yyyy)) return undefined
    const mm = parseInt(dateString.substring(4, 6), 10)
    if (!mm || isNaN(mm)) return undefined
    const dd = parseInt(dateString.substring(6, 8), 10)
    if (!dd || isNaN(dd)) return undefined

    return {
        yyyy,
        mm,
        dd,
    }
}

export const dateString_to_ddmmyyyy_ui3 = (dateString: string | undefined | null) => {
    const s = split_dateString(dateString)
    if (!s) return undefined
    return `${s.dd}. ${getMonthShortName(s.mm)} ${s.yyyy}`
}

Date.prototype.hhmmssfff = function () {
    const hh = this.getHours()
    const mm = this.getMinutes()
    const ss = this.getSeconds()
    const fff = this.getMilliseconds()
    return [
        (hh > 9 ? '' : '0') + hh,
        ':',
        (mm > 9 ? '' : '0') + mm,
        ':',
        (ss > 9 ? '' : '0') + ss,
        ':',
        (fff > 9 ? '' : '0') + (fff > 99 ? '' : '0') + fff,
    ].join('')
}

Date.prototype.hhmmss = function () {
    const hh = this.getHours()
    const mm = this.getMinutes()
    const ss = this.getSeconds()
    return [(hh > 9 ? '' : '0') + hh, ':', (mm > 9 ? '' : '0') + mm, ':', (ss > 9 ? '' : '0') + ss].join('')
}

Date.prototype.yyyymmdd = function () {
    const mm = this.getMonth() + 1 // getMonth() is zero-based
    const dd = this.getDate()
    return [this.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('')
}
Date.prototype.yyyymmddAsNumber = function () {
    const mm = this.getMonth() + 1 // getMonth() is zero-based
    const dd = this.getDate()
    return this.getFullYear() * 10000 + mm * 100 + dd
}
Date.prototype.yyyymm = function () {
    const mm = this.getMonth() + 1 // getMonth() is zero-based
    const year = this.getFullYear()
    return year * 100 + mm
}

export const getDayName = (day: number) => {
    switch (day) {
        case 0:
            return 'Sunday'
        case 1:
            return 'Monday'
        case 2:
            return 'Tuesday'
        case 3:
            return 'Wednesday'
        case 4:
            return 'Thursday'
        case 5:
            return 'Friday'
        case 6:
            return 'Saturday'
        default:
            return '???'
    }
}

export const getMonthShortName = (mm: number) => {
    switch (mm) {
        case 1:
            return 'Jan'
        case 2:
            return 'Feb'
        case 3:
            return 'Mar'
        case 4:
            return 'Apr'
        case 5:
            return 'May'
        case 6:
            return 'Jun'
        case 7:
            return 'Jul'
        case 8:
            return 'Aug'
        case 9:
            return 'Sep'
        case 10:
            return 'Oct'
        case 11:
            return 'Nov'
        case 12:
            return 'Dec'
        default:
            return '???'
    }
}

Date.prototype.day_name = function () {
    const d = this.getDay()
    return getDayName(d)
}

Date.prototype.month_shortname = function () {
    const mm = this.getMonth() + 1 // getMonth() is zero-based
    return getMonthShortName(mm)
}
Date.prototype.monthyyyy = function () {
    const month = this.month_shortname()
    const year = this.getFullYear()
    const mm = this.getMonth() + 1
    return { yyyymm: year * 100 + mm, text: `${month} ${this.getFullYear()}` }
}

Date.prototype.hhmmddmmyyyy = function () {
    const hh = this.getHours()
    const mm = this.getMinutes()
    const mo = this.getMonth() + 1 // getMonth() is zero-based
    const dd = this.getDate()

    return [
        (hh > 9 ? '' : '0') + hh,
        ':',
        (mm > 9 ? '' : '0') + mm,
        ' ',
        (dd > 9 ? '' : '0') + dd,
        '/',
        (mo > 9 ? '' : '0') + mo,
        '-',
        this.getFullYear(),
    ].join('')
}
Date.prototype.ddmmyyyy_ui = function () {
    const mo = this.getMonth() + 1 // getMonth() is zero-based
    const dd = this.getDate()

    return `${dd}/${mo}-${this.getFullYear() % 100}`
}
Date.prototype.ddmmyyyy_ui2 = function () {
    const month = this.month_shortname()
    const dd = this.getDate()

    return `${dd}. ${month} ${this.getFullYear()}`
}

Date.prototype.HHMM_ui2 = function () {
    const hh = this.getHours()
    const mm = this.getMinutes()

    return [(hh > 9 ? '' : '0') + hh, ':', (mm > 9 ? '' : '0') + mm].join('')
}

Date.prototype.HHMM_ddmmyyyy_ui2 = function () {
    return `${this.HHMM_ui2()} ${this.ddmmyyyy_ui2()}`
}

Date.prototype.HHMM_ddmmyyyy_ui3 = function () {
    return `${this.HHMM_ui2()} ${this.ddmmyyyy_ui()}`
}

Date.prototype.ddmmyyyy_HHMM_ui2 = function () {
    return `${this.ddmmyyyy_ui2()} ${this.HHMM_ui2()}`
}

Date.prototype.ddmmyyyy_ui3 = function () {
    //console.log('ddmmyyyy_ui3 called')
    const month = this.month_shortname()
    const dd = this.getDate()

    return `${dd}. ${month} '${this.getFullYear() % 100}`
}

Date.prototype.ddmmyyyy_ui4 = function () {
    //console.log('ddmmyyyy_ui3 called')
    const month = this.month_shortname()
    const dd = this.getDate()

    return `${this.day_name()} ${dd}. ${month} ${this.getFullYear()}`
}

Date.prototype.ddmmyyyy_data = function () {
    const mo = this.getMonth() + 1 // getMonth() is zero-based
    const dd = this.getDate()

    return [(dd > 9 ? '' : '0') + dd, (mo > 9 ? '' : '0') + mo, this.getFullYear()].join('')
}

Date.prototype.yyyymmddhhMMssfff_data = function () {
    const mo = this.getMonth() + 1 // getMonth() is zero-based
    const dd = this.getDate()
    const hh = this.getHours()
    const MM = this.getMinutes()
    const ss = this.getSeconds()

    return [
        this.getFullYear(),
        (mo > 9 ? '' : '0') + mo,
        (dd > 9 ? '' : '0') + dd,
        (hh > 9 ? '' : '0') + hh,
        (MM > 9 ? '' : '0') + MM,
        (ss > 9 ? '' : '0') + ss,
        Util.pad(this.getMilliseconds(), 3),
    ].join('')
}

Date.prototype.yyyymmddhhMMssfff = function () {
    const mo = this.getMonth() + 1 // getMonth() is zero-based
    const dd = this.getDate()
    const hh = this.getHours()
    const MM = this.getMinutes()
    const ss = this.getSeconds()

    return `${dd}/${mo}-${this.getFullYear()} ${(hh > 9 ? '' : '0') + hh}:${(MM > 9 ? '' : '0') + MM}:${(ss > 9 ? '' : '0') + ss}:${Util.pad(
        this.getMilliseconds(),
        3,
    )}`
}
/* eslint-enable no-extend-native */
